/* -------------------------------------------------------------------------------------------------
Restricted - Copyright (C) Siemens Healthcare GmbH/Siemens Medical Solutions USA, Inc., 2021. All rights reserved
------------------------------------------------------------------------------------------------- */
export var getDecimalNumberPrecision = function (numbersInString) {
  let numberOfDecimalPoints;
  numberOfDecimalPoints = 0;
  numberOfDecimalPoints = numbersInString.split('.')[1].length;
  return numberOfDecimalPoints;
};
